module.exports = __webpack_public_path__ + "media/kr_web_30w.d011c1d8.mp4";